import { default as investment } from './investment-robot/nl.json';
import { default as funds } from './funds-robot/nl.json';
import { default as pension } from './pension-robot/nl.json';

import { default as i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

// Export is needed to provide typing to the .d.ts file of react-i18next
const translationResources = {
    nl: { funds, investment, pension },
} as const;

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: 'nl',
        resources: translationResources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        ns: ['funds', 'investment', 'pension'],
    });

export { i18n, translationResources };
